{
  "id": "campaign-041",
  "name": "Sleepy Meadow",
  "seed": "campaign:41",
  "startDir": "W",
  "mowerRule": {
    "kind": "minTier",
    "tier": 0
  },
  "rows": [
    "RRRR........",
    "RRRR..q.....",
    "____........",
    "...#.....#..",
    "....#.y.....",
    ".......vvv~.",
    ".......vvv~~",
    "....y....~y.",
    "............",
    "fffff..fffff",
    "............",
    "............",
    ".......T..T.",
    "............",
    "...........S"
  ],
  "critters": [
    {
      "kind": "rabbit",
      "x": 8,
      "y": 3
    },
    {
      "kind": "rabbit",
      "x": 7,
      "y": 13
    },
    {
      "kind": "rabbit",
      "x": 2,
      "y": 5
    }
  ],
  "pickups": [
    {
      "kind": "gas",
      "x": 9,
      "y": 6
    },
    {
      "kind": "coin",
      "x": 2,
      "y": 2
    },
    {
      "kind": "coin",
      "x": 10,
      "y": 6
    },
    {
      "kind": "coin",
      "x": 1,
      "y": 2
    },
    {
      "kind": "coin",
      "x": 5,
      "y": 10
    },
    {
      "kind": "coin",
      "x": 5,
      "y": 12
    },
    {
      "kind": "coin",
      "x": 5,
      "y": 2
    }
  ],
  "generatorVersion": 3,
  "level": 41,
  "biome": "farm",
  "par": {
    "reel": 5601,
    "push": 4696,
    "selfPropelled": 4332,
    "tractor": 4233,
    "zeroTurn": 2997,
    "fairway": 2026
  },
  "routeTries": {
    "par": {
      "reel": 0,
      "push": 0,
      "selfPropelled": 0,
      "tractor": 0,
      "zeroTurn": 0,
      "fairway": 17
    }
  }
}
